import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Badge.styles';

const Badge = ({ children, ...props }) => (
  <S.Badge {...props}>{children}</S.Badge>
);

Badge.propTypes = {
  children: PropTypes.string,
};

export default Badge;
